
import { motion } from 'framer-motion';

export default function ContactMap() {
  return (
    <motion.section
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true }}
      className="relative py-14 sm:py-24 bg-[#050505]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-8 sm:mb-12">
          <span
            className="text-[#00E5FF] text-[10px] sm:text-sm tracking-[0.2em] sm:tracking-[0.3em] uppercase font-semibold"
            style={{ fontFamily: 'Orbitron, sans-serif' }}
          >
            Lokalizacja
          </span>
          <h2
            className="text-2xl sm:text-4xl font-bold text-white mt-3 sm:mt-4 leading-tight"
            style={{ fontFamily: 'Rajdhani, sans-serif' }}
          >
            Znajdź <span className="text-[#00E5FF]">Nas</span>
          </h2>
          <p
            className="text-[#C0C7CF] text-xs sm:text-base mt-3 sm:mt-4 max-w-2xl mx-auto px-2"
            style={{ fontFamily: 'Inter, sans-serif' }}
          >
            Zabłotce 146, 38-500 Sanok — województwo podkarpackie
          </p>
        </div>

        <div className="relative border border-[#00E5FF]/20 overflow-hidden group">
          <div className="absolute top-0 left-0 right-0 h-[2px] bg-gradient-to-r from-transparent via-[#00E5FF] to-transparent z-10"></div>

          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2596.5!2d22.15!3d49.573!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x473c4e5b5b5b5b5b%3A0x0!2sZab%C5%82otce%20146%2C%2038-500%20Sanok!5e0!3m2!1spl!2spl!4v1700000000000!5m2!1spl!2spl"
            width="100%"
            height="100%"
            style={{
              border: 0,
              filter:
                'grayscale(80%) contrast(1.1) brightness(0.7) hue-rotate(180deg)',
            }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Lokalizacja EUREKA - Zabłotce 146, Sanok"
            className="w-full h-[280px] sm:h-[400px] md:h-[500px]"
          />

          <div className="absolute bottom-0 left-0 right-0 h-[2px] bg-gradient-to-r from-transparent via-[#00E5FF] to-transparent z-10"></div>

          {/* Desktop overlay */}
          <div className="hidden sm:block absolute bottom-6 right-6 bg-[#050505]/90 backdrop-blur-sm border border-[#00E5FF]/30 p-4 z-10">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center bg-[#00E5FF]/10 border border-[#00E5FF]">
                <i className="ri-map-pin-line text-lg text-[#00E5FF]"></i>
              </div>
              <div>
                <p
                  className="text-white text-sm font-bold"
                  style={{ fontFamily: 'Orbitron, sans-serif' }}
                >
                  EUREKA
                </p>
                <p
                  className="text-[#C0C7CF] text-xs"
                  style={{ fontFamily: 'Inter, sans-serif' }}
                >
                  Zabłotce 146, 38-500 Sanok
                </p>
              </div>
              <a
                href="https://maps.google.com/?q=Zab%C5%82otce+146+38-500+Sanok"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="ml-4 px-4 py-2 border border-[#00E5FF] text-[#00E5FF] text-xs font-bold hover:bg-[#00E5FF] hover:text-[#050505] transition-all duration-300 cursor-pointer whitespace-nowrap"
                style={{ fontFamily: 'Orbitron, sans-serif' }}
              >
                Nawiguj
              </a>
            </div>
          </div>

          {/* Mobile overlay — bottom full width */}
          <div className="sm:hidden absolute bottom-0 left-0 right-0 bg-[#050505]/95 backdrop-blur-sm border-t border-[#00E5FF]/30 p-3 z-10">
            <div className="flex items-center justify-between gap-2">
              <div className="flex items-center gap-2 min-w-0">
                <div className="w-8 h-8 flex items-center justify-center bg-[#00E5FF]/10 border border-[#00E5FF] flex-shrink-0">
                  <i className="ri-map-pin-line text-sm text-[#00E5FF]"></i>
                </div>
                <div className="min-w-0">
                  <p
                    className="text-white text-xs font-bold truncate"
                    style={{ fontFamily: 'Orbitron, sans-serif' }}
                  >
                    EUREKA
                  </p>
                  <p
                    className="text-[#C0C7CF] text-[10px] truncate"
                    style={{ fontFamily: 'Inter, sans-serif' }}
                  >
                    Zabłotce 146, Sanok
                  </p>
                </div>
              </div>
              <a
                href="https://maps.google.com/?q=Zab%C5%82otce+146+38-500+Sanok"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="px-4 py-2 bg-[#00E5FF] text-[#050505] text-[10px] font-bold cursor-pointer whitespace-nowrap flex-shrink-0"
                style={{ fontFamily: 'Orbitron, sans-serif' }}
              >
                <i className="ri-navigation-line mr-1"></i>
                Nawiguj
              </a>
            </div>
          </div>
        </div>
      </div>
    </motion.section>
  );
}
